var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 16,
    viewBox: "0 0 45 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.67037 7.64645C7.47511 7.84171 7.47511 8.15829 7.67037 8.35355L10.8524 11.5355C11.0476 11.7308 11.3642 11.7308 11.5595 11.5355C11.7547 11.3403 11.7547 11.0237 11.5595 10.8284L8.73103 8L11.5595 5.17157C11.7547 4.97631 11.7547 4.65973 11.5595 4.46447C11.3642 4.2692 11.0476 4.2692 10.8524 4.46447L7.67037 7.64645ZM37.3299 8.35355C37.5251 8.15829 37.5251 7.84171 37.3299 7.64645L34.1479 4.46447C33.9526 4.2692 33.636 4.2692 33.4408 4.46447C33.2455 4.65973 33.2455 4.97631 33.4408 5.17157L36.2692 8L33.4408 10.8284C33.2455 11.0237 33.2455 11.3403 33.4408 11.5355C33.636 11.7308 33.9526 11.7308 34.1479 11.5355L37.3299 8.35355ZM8.02393 8.5H36.9763V7.5H8.02393V8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.67865a97b7bf9e2038d7d2c2ab71d98a.svg";
export { ForwardRef as ReactComponent };